import { useIndexedDB } from 'react-indexed-db';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { deleteSelectedPatient } from '../../redux/Patient/PatientAction';

const ClosePatient = () => {
    const patients = useSelector((state) => state?.patient?.listOfPatients);
    const history = useHistory();
    const { pathname } = useLocation();
    const clinicId = pathname?.split('/').filter((item) => item)[0];
    const dispatch = useDispatch();
    const { deleteRecord } = useIndexedDB('patients');
    const id = useSelector((state) => state.patient.patient.profile?.id);

    const handleClosePatient = (patient) => {
        if (patient?.id) {
            if (patients?.length < 2) {
                history.replace(`/${clinicId}/patients`);
            } else if (patient?.id === id) {
                const index = patients.findIndex((item) => item.id === +patient?.id);
                let prevPatient;
                if (index === 0) {
                    prevPatient = patients[1]?.id;
                } else {
                    prevPatient = patients[index - 1]?.id;
                }
                history.replace(`/${clinicId}/patient/${prevPatient}/forms/form`);
            }

            deleteRecord(+patient?.id);
            dispatch(deleteSelectedPatient(+patient?.id));
        }
    };
    return { handleClosePatient };
};

export default ClosePatient;
